/** The card wait: the star breathes inside the circle while Shopify POS takes the card. When the sale flips to paid the
 *  screen swaps this for `DoneMark kind="paid"`; the star's last frame and the paid star's first frame line up, so the
 *  turn reads as the same star settling. */
export function StarWait() {
  return <div className="done__tick done__tick--wait" aria-hidden="true"><span className="done__star done__star--breathe" /></div>
}
